// src/components/ui/forms/PartnersSearchBar/PartnersSearchBarShadcn.jsx
import React from 'react';
import { Search, Loader2 } from 'lucide-react';

// shadcn components
import { Input } from '../../input';
import { Button } from '../../button';

import { cn } from '../../../../utils/cn';

const PartnersSearchBarShadcn = ({
  value,
  onChange,
  onSearch,
  placeholder = "Search by business name or service type...",
  isLoading = false,
  disabled = false,
  className = ''
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch && value.trim() && !disabled) {
      onSearch(value.trim());
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={cn("relative", className)}>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Search className="w-4 h-4 text-muted-foreground" />
        </div>

        <Input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          className="pl-10 pr-24"
          disabled={isLoading || disabled}
        />

        <div className="absolute inset-y-0 right-0 pr-2 flex items-center">
          <Button
            type="submit"
            disabled={isLoading || !value.trim() || disabled}
            size="sm"
            className="flex items-center gap-2"
          >
            {isLoading ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <Search className="w-4 h-4" />
            )}
            {isLoading ? 'Searching...' : 'Search'}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default PartnersSearchBarShadcn;